module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"menu":{"delete":"削除","false_positive":"誤検出"}},"en":{"menu":{"delete":"Delete","false_positive":"False positive"}}}')
  delete Component.options._Ctor
}
